"use client";

import React, { useEffect } from "react";
import { twMerge } from "tailwind-merge";
import fetchAPI from "@/functions/fetchAPI";
import { useState } from "react";
import HeaderDashboard from "./_component/header";
import TrendPembelanjaan from "./_component/trend-pembelanjaan";
import TopMitra from "./_component/top-mitra";
import TopProduct from "./_component/top-product";
import { format } from "date-fns";
import useHeader from "@/functions/useHeader";

const formatFieldOrders = [
  {
    title: "Order Aktif",
    key: "pending",
  },
  {
    title: "Perlu Diproses",
    key: "process",
  },
  {
    title: "Order Dipacking",
    key: "packing",
  },
  {
    title: "Order Terkirim",
    key: "delivery",
  },
  // {
  //   title: "Order Dibatalkan",
  //   key: "canceled",
  // },
];

export default function Dashboard({ paddingStyle }) {
  const { session } = useHeader();
  const [listOrderActivity, setListOrderActivity] = useState([]);
  const [datas, setDatas] = useState();
  const [date, setDate] = useState({
    date_from: "", // format yyyy-mm-dd
    date_until: "",
    date_numeric: 0, // format number
  });

  async function getReportDashboard(body) {
    try {
      let uri = `reports/dashboard/mitra/status`;
      let res = await fetchAPI({
        uri,
        method: "POST",
        token: session?.user?.token,
        body: {
          date_from: !body?.date_from
            ? ""
            : format(body?.date_from, "yyyy-MM-dd"),
          date_until: !body?.date_until
            ? ""
            : format(body?.date_until, "yyyy-MM-dd"),
          date_numeric: body?.date_numeric,
        },
      });

      setDate(body);

      if ((res?.error || res?.error?.message)?.length > 0)
        throw new Error(res?.error || res?.error?.message);

      formatFieldOrders.forEach((a) => {
        a.value = res?.data?.total_number_transaction[a?.key]?.amount ?? 0;
      });
      setDatas(res?.data);
      setListOrderActivity(formatFieldOrders);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getReportDashboard({ ...date, getFirst: true });
  }, []);

  return (
    <React.Fragment>
      <div className={twMerge(paddingStyle, "flex flex-col gap-8")}>
        <HeaderDashboard getReportDashboard={getReportDashboard} />
        <div className='flex flex-col gap-4'>
          {/* order Activity */}
          <div className='flex flex-col gap-6'>
            <div
              className='gap-4 justify-between items-center
        grid grid-cols-2 xs:grid-cols-3 md:grid-cols-4
        '>
              {listOrderActivity?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className='flex gap-4 items-center bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 xs:p-8'>
                    <div className='flex flex-col gap-1 sm:gap-2'>
                      <p className='h5-medium sm:h4-medium text-greyscaleGON-700'>
                        {item?.value}
                      </p>
                      <p className='p2-regular sm:p1-regular text-greyscaleGON-400'>
                        {item?.title}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Trend Pembelanjaan */}
          <TrendPembelanjaan
            date={date}
            datas={datas?.statistics_transaction}
          />

          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            {session?.user?.data?.mitra_level == 1 && (
              <TopMitra datas={datas?.best_seller_transaction} />
            )}
            <TopProduct datas={datas?.most_product_transaction} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
